<template>
  <div class="tree-collapse">
    <div class="header">
      <p class="col1">{{ headerTitle[0] }}</p>
      <p class="col2">{{ headerTitle[1] }}</p>
      <p class="col3">{{ headerTitle[2] }}</p>
    </div>
    <div class="body">
      <TreeCollapseItem
        v-for="(item, index) in value"
        :key="index"
        :value="item"
        :next-value="value[index + 1]"
        :child-prop="childProp"
        :max-level="maxLevel"
        @on-expand="$emit('on-expand', $event)"
      >
        <template slot="num" slot-scope="{ data }">
          <slot name="num" :data="data"></slot>
        </template>
        <template slot="btn" slot-scope="{ data }">
          <slot name="btn" :data="data"></slot>
        </template>
      </TreeCollapseItem>
    </div>
  </div>
</template>

<script>
import TreeCollapseItem from './TreeCollapseItem';
export default {
  name: 'TreeCollapse',
  components: {
    TreeCollapseItem,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    headerTitle: {
      type: Array,
      default() {
        return ['标题1', '标题2', '标题3'];
      },
    },
    childProp: {
      type: String,
      default: 'children',
    },
    // 最大层级，影响了图标展现 以及 超出该层级将被忽略
    maxLevel: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.header {
  background-color: #f6f6f6;
  padding-left: 20px;
  height: 47px;
  line-height: 47px;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  .col1 {
    flex-grow: 1;
  }
  .col2 {
    width: 370px;
  }
  .col3 {
    width: 100px;
    text-align: center;
  }
}
.body {
  padding-left: 20px;
}
</style>
